// import standalone bootstrap modal to avoid conflict with react when importing
// from main bootstrap js. Used for error modal
import 'bootstrap/js/dist/modal';
import $ from 'jquery';

const modal = {
    // configurable defaults
    element: $('#PopUpMessage'),
    bodySelector: '.modal-body',
    onModalShow: 'show.bs.modal',
    body: null,

    setup: function (config = {}) {
        // set properties passed into config
        for (const key in config) {
            if (key in this === false) {
                continue;
            }

            this[key] = config[key];
        }

        if (this.element.length < 1) {
            return;
        }
        this.body = this.element.find(this.bodySelector);
        this.setBody(config.bodyContent);
    },

    open: function () {
        if (this.body?.length < 1) {
            return;
        }

        // bootstrap modal
        this.element.modal();
    },

    setBody: function (bodyContent) {
        if (this.body.length < 1) {
            return;
        }

        this.body.text(bodyContent);
    },
};

const errorModal = Object.create(modal);

// default error message
errorModal.errorMessage = 'We are unable to complete your request at the moment, please click ‘OK’ to close this window and try again.';

errorModal.setBody = function () {
    modal.setBody.call(this, this.errorMessage);
};

export { errorModal };
